const services = [
  {
    icon: 'ri-temp-cold-line',
    title: 'Installation sur mesure',
    desc: "Étude personnalisée de vos besoins et installation de systèmes de climatisation adaptés à votre espace, pour une performance optimale et une intégration discrète.",
  },
  {
    icon: 'ri-tools-line',
    title: 'Maintenance préventive',
    desc: "Entretien complet de vos équipements afin d'assurer leur longévité, leurs performances et une qualité de l'air irréprochable.",
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Dépannage',
    desc: "Intervention rapide et efficace pour diagnostiquer et résoudre toute panne, avec un service fiable et réactif.",
  },
  {
    icon: 'ri-sun-line',
    title: 'PAC — Pompe à Chaleur',
    desc: "Installation et entretien de pompes à chaleur air/air et air/eau, pour un chauffage et une climatisation performants tout en maîtrisant vos dépenses énergétiques.",
  },
  {
    icon: 'ri-windy-line',
    title: 'VMC / CTA',
    desc: "Pose et entretien de systèmes de ventilation mécanique contrôlée et centrales de traitement d'air pour une qualité de l'air optimale.",
  },
  {
    icon: 'ri-leaf-line',
    title: 'Bilan énergétique',
    desc: "Analysez votre installation pour optimiser votre consommation et améliorer votre confort tout en maîtrisant vos dépenses énergétiques.",
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Contrats d\'entretien personnalisés',
    desc: "Formules adaptées à vos besoins pour un suivi régulier et une tranquillité totale toute l'année.",
  },
];

const ServicesSection = () => (
  <section id="services" className="w-full py-24" style={{ background: 'linear-gradient(180deg, #f0f8fc 0%, #ffffff 100%)' }}>
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-16">
        <span
          className="inline-block text-white text-xs font-bold px-5 py-2 rounded-full mb-4 tracking-widest uppercase"
          style={{ background: 'linear-gradient(90deg, #002060 0%, #1a8abf 100%)' }}
        >
          Nos Prestations
        </span>
        <h2 className="text-4xl lg:text-5xl font-black leading-tight mb-4" style={{ color: '#002060' }}>
          Des solutions complètes pour<br />tous vos besoins thermiques
        </h2>
        <p className="text-[#4a6272] text-lg max-w-xl mx-auto">
          Nous couvrons l'ensemble du cycle de vie de vos équipements, de l'installation à la maintenance, en passant par le dépannage.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map(({ icon, title, desc }) => (
          <article
            key={title}
            className="group rounded-2xl border border-[#d0eaf7] hover:border-[#1a8abf] transition-all duration-300 cursor-pointer hover:-translate-y-1 bg-white p-6"
          >
            <div
              className="w-12 h-12 flex items-center justify-center rounded-xl mb-5"
              style={{ background: 'linear-gradient(135deg, #002060 0%, #1a8abf 100%)' }}
            >
              <i className={`${icon} text-white text-xl`} />
            </div>
            <h3 className="text-lg font-bold mb-2" style={{ color: '#002060' }}>{title}</h3>
            <p className="text-[#4a6272] text-sm leading-relaxed">{desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
